/**
 * Formats Firebase auth error messages into readable text
 * @param {Error} error - The Firebase auth error object
 * @returns {string} Cleaned and formatted error message
 */
export const formatFirebaseError = (error) => {
  if (!error?.code) {
    return 'An unexpected error occurred';
  }

  const errorCode = error.code.match(/auth\/(.+?)\)?$/)?.[1] || error.code;

  return errorCode
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Maps error codes to user-friendly messages
 * @param {Error} error - Firebase Auth error object
 * @returns {string} Readable explanation
 */
export const generateCleanErrorMessage = (error) => {
  const map = {
    'auth/user-not-found': 'No account was found with that email.',
    'auth/wrong-password': 'The password entered is incorrect.',
    'auth/internal-error': 'Something went wrong on our end. Please try again.',
  };

  if (map[error.code]) return map[error.code];
  return `An error was encountered. ${error.message}`;
};

